import { IEntity } from '../../../core/primitives/entities/IEntity.interface';
import { Logger } from '../../../core/utilities/logging/logger';
import { NotificationEnum } from '../enums/notifications.enum';

export interface INotificationMessage<TContent> extends IEntity<string> {
    type: string;
    title: string;
    details: string;
    content: TContent;
    notifier: string;
    createdOn: string;
    isReaded: boolean;
}

export class NotificationMessage<TContent> implements INotificationMessage<TContent> {
    id: string;
    type: string;
    title: string;
    details: string;
    content: TContent;
    notifier: string;
    createdOn: string;
    createdOnDate: Date;
    isReaded: boolean;

    private constructor(message: INotificationMessage<TContent>) {
        this.id = message.id;
        this.type = message.type;
        this.title = message.title;
        this.details = message.details;
        this.content = message.content;
        this.notifier = message.notifier;
        this.createdOn = message.createdOn;
        this.createdOnDate = new Date(message.createdOn);
        this.isReaded = message.isReaded;
    }

    public static create(message: INotificationMessage<any>): NotificationMessage<any> {
        return new NotificationMessage<any>(message);
    }

    public static createMany<TContent>(messages: INotificationMessage<TContent>[]): NotificationMessage<TContent>[] {
        return messages.map(NotificationMessage.create);
    }

    public markAsReaded(): NotificationMessage<TContent> {
        this.isReaded = true;
        return this;
    }

    public isOfType(type: string): boolean {
        return this.type.toLowerCase() === type.toLowerCase();
    }

    public getRouteUrl(): string | undefined {
        return NotificationEnum.fromName<NotificationEnum>(this.type)?.getNotificationRoute(this);
    }
}
